"use client";

import { useGraph } from "./GraphContext";
import { useToolLock } from "@/lib/ToolLockContext";
import { useModal } from "@/components/ui/ModalProvider";

function GraphIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* L-shaped axes */}
      <path d="M4 4v16h16" />
      {/* Pronounced sine-likt kurva som tydligt signalerar "graf av en funktion" */}
      <path d="M5 17 Q 8 5, 12 13 T 20 8" />
    </svg>
  );
}

export default function GraphButton() {
  const { open, toggleGraph } = useGraph();
  const { graphLocked: locked, calcLocked } = useToolLock();
  // Graph locked while the calculator is open: GeoGebra itself is not allowed
  // here (a Ma 1 prov, or a class that unlocks only the calculator).
  const baraGraf = locked && !calcLocked;
  const { notify } = useModal();

  function handleClick() {
    if (locked) {
      notify(
        baraGraf
          ? {
              title: "GeoGebra används inte här",
              message: "Använd miniräknaren och formelbladet uppe i menyn.",
            }
          : {
              title: "Inga digitala verktyg på denna uppgift",
              message: "Den här uppgiften ska lösas utan grafritare. Försök först för hand.",
            },
      );
      return;
    }
    toggleGraph();
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Graf"
      title={
        locked
          ? baraGraf
            ? "GeoGebra används inte här — använd miniräknaren och formelbladet"
            : "Inga digitala verktyg på denna uppgift"
          : open
          ? "Stäng graf-verktyget"
          : "Öppna graf-verktyget — GeoGebra"
      }
      className={`-ml-2 p-2 rounded-md transition-colors ${
        open
          ? "text-[var(--color-accent)]"
          : "text-[var(--color-nav-text)] hover:bg-[var(--color-nav-border)]"
      }`}
    >
      <GraphIcon className="w-5 h-5" />
    </button>
  );
}
